export interface VisualAssessmentBoxProps {
  /**
   * Rating value from 1 to 4
   * 1 - Poor condition
   * 2 - Below average condition
   * 3 - Good condition
   * 4 - Excellent condition
   */
  rating: 1 | 2 | 3 | 4;
  /**
   * Optional className for custom styling
   */
  className?: string;
}

export enum VisualAssessmentRating {
  POOR = 1,
  BELOW_AVERAGE = 2,
  GOOD = 3,
  EXCELLENT = 4,
}

export const getVisualAssessmentRating = (
  rating: 1 | 2 | 3 | 4,
): VisualAssessmentRating => {
  switch (rating) {
    case 1:
      return VisualAssessmentRating.POOR;
    case 2:
      return VisualAssessmentRating.BELOW_AVERAGE;
    case 3:
      return VisualAssessmentRating.GOOD;
    case 4:
      return VisualAssessmentRating.EXCELLENT;
    default:
      return VisualAssessmentRating.GOOD;
  }
};

export const getVisualAssessmentText = (
  rating: VisualAssessmentRating,
): string => {
  switch (rating) {
    case VisualAssessmentRating.POOR:
      return 'Bardzo zła';
    case VisualAssessmentRating.BELOW_AVERAGE:
      return 'Zła';
    case VisualAssessmentRating.GOOD:
      return 'Adekwatna do przebiegu';
    case VisualAssessmentRating.EXCELLENT:
      return 'Dobra';
    default:
      return 'Adekwatna do przebiegu';
  }
};

export const getVisualAssessmentStyles = (
  rating: VisualAssessmentRating,
): string => {
  switch (rating) {
    case VisualAssessmentRating.POOR:
      return 'bg-red-200 text-red-700';
    case VisualAssessmentRating.BELOW_AVERAGE:
      return 'bg-orange-200 text-orange-700';
    case VisualAssessmentRating.GOOD:
      return 'bg-gray-300 text-green-700';
    case VisualAssessmentRating.EXCELLENT:
      return 'bg-green-200 text-green-700';
    default:
      return 'bg-gray-300 text-green-700';
  }
};
